import React, { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateData } from "../../utility/managerApi";

function EditReceiptTemplate({ template, setViewModal }) {
  const queryClient = useQueryClient();

  const [newData, setNewData] = useState({
    header_line_one: template?.header_line_one,
    header_line_two: template?.header_line_two,
    header_line_three: template?.header_line_three,
    footer_line_one: template?.footer_line_one,
    footer_line_two: template?.footer_line_two,
    footer_line_three: template?.footer_line_three,
    number_of_pages: template?.number_of_pages,
  });

  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setNewData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const updateReceipt = useMutation({
    mutationFn: () =>
      updateData(`receipt-template/update/`, template?.id, newData),
    onSuccess: () => {
      setViewModal(false);
      queryClient.invalidateQueries(["managertemplate"]);
    },
  });

  const handleUpdate = () => {
    updateReceipt.mutate(newData);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-4 ">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => setViewModal(false)}
            className="cursor-pointer text-black mb-2"
          />
        </div>
        <div className="flex  items-center gap-3 justify-center mb-2">
          <h3 className="font-semibold text-center">Number of receipts :</h3>
          <input
            className="border-2 border-gray-300 w-12 pl-2  rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="number_of_pages"
            type="number"
            name="number_of_pages"
            // id="email"
            value={newData?.number_of_pages}
            onChange={handleChange}
            // required
          />
        </div>

        <div className="w-[300px] mx-auto border border-black p-2 text-sm font-sans">
          {/* Header */}
          <div className="text-center mb-4">
            <h3 className="font-semibold">Header Edit</h3>
            <input
              className="border-2 border-gray-300 p-1 mb-1 rounded-md focus:border-teal-500 focus:outline-none "
              placeholder="Company Name"
              type="text"
              name="header_line_one"
              // id="email"
              value={newData?.header_line_one}
              onChange={handleChange}
              required
            />

            <input
              className="border-2 border-gray-300 p-1 mb-1 rounded-md focus:border-teal-500 focus:outline-none "
              placeholder="Header 2"
              type="text"
              name="header_line_two"
              // id="email"
              value={newData?.header_line_two}
              onChange={handleChange}
              required
            />
            <input
              className="border-2 border-gray-300 p-1 mb-1 rounded-md focus:border-teal-500 focus:outline-none "
              placeholder="Header 3"
              type="text"
              name="header_line_three"
              // id="email"
              value={newData?.header_line_three}
              onChange={handleChange}
              required
            />
          </div>
          {/* Receipt Info */}
          <div className="text-center mb-4">
            <p>
              {new Date().toLocaleDateString()}{" "}
              {new Date().toLocaleTimeString()}
            </p>
            <p>Cashier</p>
          </div>
          <hr className="border-t border-dashed border-black my-2" />
          {/* Items */}
          <div className="mb-4">
            <div className="flex justify-between mb-2">
              <span>Product1 x 2</span>
              <span>$400</span>
            </div>
            <div className="flex justify-between mb-2">
              <span>Product1 x 2</span>
              <span>$400</span>
            </div>
          </div>
          {/* Footer */}
          <div className="text-center mb-4">
            <div className="flex justify-between">
              <span className="font-bold">Total</span>
              <span className="font-bold">$800</span>
            </div>
            <div>
              {/* <p>{response?.data?.loyaltyPointsData?.CustomerLoyaltyPoint}</p> */}
              {/* <p>{response?.data?.loyaltyPointsData?.Discount}</p> */}
            </div>
          </div>
          <hr className="border-t border-dashed border-black my-2" />
          {/* Barcode */}
          {/* <div className="text-center mt-4">
    
          {/* Label */}
          <div className="text-center flex flex-col px-6  mt-2">
            <h3 className="font-semibold">Footer Edit</h3>
            <input
              className="border-2 border-gray-300 p-1 mb-1 rounded-md focus:border-teal-500 focus:outline-none "
              placeholder="footer"
              type="text"
              name="footer_line_one"
              // id="email"
              value={newData?.footer_line_one}
              onChange={handleChange}
              required
            />
            <input
              className="border-2 border-gray-300 p-1 mb-1 rounded-md focus:border-teal-500 focus:outline-none "
              placeholder="footer two"
              type="text "
              name="footer_line_two"
              // id="email"
              value={newData?.footer_line_two}
              onChange={handleChange}
              required
            />
            <input
              className="border-2 border-gray-300 p-1 mb-1 rounded-md focus:border-teal-500 focus:outline-none "
              placeholder="footer 3"
              type="text "
              name="footer_line_three"
              // id="email"
              value={newData?.footer_line_three}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div>
          <button
            onClick={handleUpdate}
            className="w-full h-full bg-blue-500 hover:bg-blue-600 text-white rounded-md py-2 mt-3"
            disabled={updateReceipt?.isPending}
          >
            {updateReceipt.isPending ? "Updating..." : "Update Receipt"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditReceiptTemplate;
